var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 21,
    height: 21,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 3.5H4.99531C4.17031 3.5 3.5 4.17969 3.5 5.01406V22.9859C3.5 23.8203 4.17031 24.5 4.99531 24.5H23C23.825 24.5 24.5 23.8203 24.5 22.9859V5.01406C24.5 4.17969 23.825 3.5 23 3.5ZM9.84687 21.5H6.73438V11.4781H9.85156V21.5H9.84687ZM8.29062 10.1094C7.29219 10.1094 6.48594 9.29844 6.48594 8.30469C6.48594 7.31094 7.29219 6.5 8.29062 6.5C9.28437 6.5 10.0953 7.31094 10.0953 8.30469C10.0953 9.30312 9.28906 10.1094 8.29062 10.1094V10.1094ZM21.5141 21.5H18.4016V16.625C18.4016 15.4625 18.3781 13.9672 16.7844 13.9672C15.1625 13.9672 14.9141 15.2328 14.9141 16.5406V21.5H11.8016V11.4781H14.7875V12.8469H14.8297C15.2469 12.0594 16.2641 11.2297 17.7781 11.2297C20.9281 11.2297 21.5141 13.3062 21.5141 16.0062V21.5V21.5Z",
    fill: "#2867B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin2);
export default __webpack_public_path__ + "static/media/linkedin2.087135aa7d171d256dd9636c10cccfe5.svg";
export { ForwardRef as ReactComponent };